import { isApplicationNonProd } from 'Utilities/helpers';
import { safeLocalStorage } from 'Utilities/storages';

if (isApplicationNonProd) {
  const startMsw = async () => {
    const [setupWorker, addMswRoutes] = await Promise.all([
      import('msw/browser').then((module) => module.setupWorker),
      import('../../../../client/mocks/browser').then((module) => module.addMswRoutes),
    ]).catch((error) => {
      window?.Sentry?.captureException?.(error);
      return [];
    });

    if (!setupWorker || !addMswRoutes) {
      return;
    }

    const mswWorker = setupWorker();
    await mswWorker.start({ onUnhandledRequest: 'bypass' });
    mswWorker.use(...addMswRoutes() as []);

    window.mswStop = () => mswWorker.stop();

    window.addEventListener('mswStorage', () => {
      mswWorker.resetHandlers();
      mswWorker.use(...addMswRoutes() as []);
    });
  };

  if (safeLocalStorage.getItem('developersWidgetVisible')) {
    await startMsw();
  }
}
